import React from 'react';
import {Link} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">

                        {/* 1st block */}
                        <div className="col-span-12 lg:col-span-4">
                            <div
                                className="box-border border-b-4 border-brand p-8 bg-brand-50 text-gray-600  rounded-lg xl:w-80 mx-auto">
                                <div className='text-md font-medium text-gray-600'>
                                    <div className="mr-9">
                                        <p><b>M&rivet, s.r.o.</b></p>
                                        <p>Závodská 4</p>
                                        <p>010 01 Žilina</p>

                                        <div className="pt-3">
                                            <p>IČO: 36300845</p>
                                            <p>DIČ: 2020111500</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 2nd block */}
                        <div className="col-span-6 lg:col-span-4 md:col-span-6  mx-auto">
                            <h6 className="text-brand text-xl font-bold mb-4">Odkazy</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <HashLink to="/#main"
                                              className="text-brand hover:text-black transition  underline">O
                                        nás</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services"
                                              className="text-brand hover:text-black transition  underline">Služby</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#clients"
                                              className="text-brand hover:text-black transition  underline">Referencie</HashLink>
                                </li>
                            </ul>
                        </div>

                        {/* 3rd block */}
                        <div className="col-span-6 lg:col-span-4 md:col-span-6  mx-auto">
                            <h6 className="text-brand text-xl font-bold mb-4">Naš služby</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <Link to="/predaj-naradia"
                                          className="text-brand hover:text-black transition  underline">
                                        Predaj náradia</Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/rezanie-vodnym-lucom"
                                          className="text-brand hover:text-black transition  underline">
                                        Rezanie vodným lúčom</Link>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services"
                                              className="text-brand hover:text-black transition  underline">Poradenstvo</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="/#services"
                                              className="text-brand hover:text-black transition  underline">Servis
                                        náradia</HashLink>
                                </li>
                            </ul>
                        </div>


                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                        <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                            <div className="text-sm text-gray-200 font-semibold py-1">
                                Copyright &copy; {new Date().getFullYear()}{"  "}
                                <HashLink
                                    to="#"
                                    className=" hover:text-gray-900"
                                >
                                    M&Rivet
                                </HashLink>. All rights reserved.
                            </div>
                        </div>
                    </div>

                </div>

            </footer>
        </>
    )
}
export default Footer;
